export default "__VITE_ASSET__DmbyJheE__"